// Continuous memberships ("Jatkuva laskutus"): sold as a subscription, the first period paid now with
// a stored card, each following period charged from the same card on its renewal day, until the
// customer cancels. The product side is defined in the venue manager (membership.continuous, only
// counted when availableinshop === 'true'); the billing period is the rolling validity
// (unit + amount) and the price per period is the chosen variation.

// The version of the fixed Cintoia consent text the customer accepts. Sent with the purchase and
// stored by the backend, so it is known later which wording was agreed to. Bump it whenever the
// texts behind 'subscription_consent' change.
export const SUBSCRIPTION_CONSENT_VERSION = 'membership-subscription-1'

// The backend copies `continuous: true` onto the shop item only for a product that really is
// continuous, so the shop item's own flag is enough here.
export const isContinuousProduct = (shopItem) => !!(shopItem && shopItem.continuous === true)

const UNIT_KEYS = { day: 'period_day', week: 'period_week', month: 'period_month', year: 'period_year' }

// The billing period in words, as it reads after a price: 'kk' for one month ('19,00 € / kk'),
// '3 kk' for three. `t` is i18next's; '' when not a rolling period.
export const periodLabel = (validity, t) => {
  if (!validity || validity.type !== 'rolling' || !UNIT_KEYS[validity.unit]) return ''
  const amount = Number(validity.amount) > 0 ? Number(validity.amount) : 1
  const unit = t(UNIT_KEYS[validity.unit])
  return amount === 1 ? unit : amount + ' ' + unit
}

// What a membership assignment says about its subscription. Assignments without any of the status
// fields (every membership bought before subscriptions, and every non-continuous one) give null, so
// the UI shows nothing rather than inventing a state.
export const subscriptionState = (assignment) => {
  if (!assignment) return null
  const state = assignment.chargestate
  if (!state) return null
  return {
    state,
    active: state === 'active',
    cancelled: state === 'cancelled',
    failed: state === 'failed',
    paused: state === 'paused',
    nextcharge: assignment.nextcharge || null,
    end: assignment.end || null,
    cardid: (assignment.subscription && assignment.subscription.cardid) || null,
  }
}
